import { Component, Input, OnInit, OnChanges } from '@angular/core';

export interface GradeBreakdownData {
  sales: number;
  spsf: number;
  realEstate: number;
  banner: number;
  competitiveImpact: number;
}

@Component({
  standalone: false,
  selector: 'mtn-overall-grade-breakdown-chart',
  templateUrl: './overall-grade-breakdown-chart.component.html',
  styleUrls: ['./overall-grade-breakdown-chart.component.scss']
})
export class OverallGradeBreakdownChartComponent implements OnInit, OnChanges {
  data: GradeBreakdownData = {
    sales: 38.75,
    spsf: 38.75,
    realEstate: 7.5,
    banner: 7.5,
    competitiveImpact: 7.5
  };

  @Input() isExpanded: boolean = false;
  @Input() showHeader: boolean = true;

  // Chart segments data
  chartSegments: any[] = [];

  // Legend items with colors matching the design
  legendItems = [
    { name: 'Sales', color: '#0047B3', key: 'sales' },
    { name: 'SPSF', color: '#006BE6', key: 'spsf' },
    { name: 'Real Estate', color: '#66B2FF', key: 'realEstate' },
    { name: 'Banner', color: '#8BC7FF', key: 'banner' },
    { name: 'Competitive Impact', color: '#ACD6FF', key: 'competitiveImpact' }
  ];

  ngOnInit(): void {
    this.generateChartSegments();
  }

  ngOnChanges(): void {
    this.generateChartSegments();
  }

  getSegmentColor(index: number): string {
    return this.legendItems[index]?.color || '#0047B3';
  }

  getSegmentPath(index: number): string {
    const total = this.data.sales + this.data.spsf + this.data.realEstate + this.data.banner + this.data.competitiveImpact;
    if (total === 0) return '';

    const centerX = 107;
    const centerY = 107;
    const radius = 106.5;
    const innerRadius = 53.25;

    let startAngle = 0;
    for (let i = 0; i < index; i++) {
      const value = this.data[this.legendItems[i].key as keyof GradeBreakdownData];
      startAngle += (value / total) * 360;
    }

    const currentValue = this.data[this.legendItems[index].key as keyof GradeBreakdownData];
    const endAngle = startAngle + (currentValue / total) * 360;

    return this.createArcPath(centerX, centerY, radius, innerRadius, startAngle, endAngle);
  }

  private createArcPath(cx: number, cy: number, r: number, innerR: number, startAngle: number, endAngle: number): string {
    const startAngleRad = (startAngle - 90) * Math.PI / 180;
    const endAngleRad = (endAngle - 90) * Math.PI / 180;

    const x1 = cx + r * Math.cos(startAngleRad);
    const y1 = cy + r * Math.sin(startAngleRad);
    const x2 = cx + r * Math.cos(endAngleRad);
    const y2 = cy + r * Math.sin(endAngleRad);

    const x3 = cx + innerR * Math.cos(endAngleRad);
    const y3 = cy + innerR * Math.sin(endAngleRad);
    const x4 = cx + innerR * Math.cos(startAngleRad);
    const y4 = cy + innerR * Math.sin(startAngleRad);

    const largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1';

    return [
      'M', x1, y1,
      'A', r, r, 0, largeArcFlag, 1, x2, y2,
      'L', x3, y3,
      'A', innerR, innerR, 0, largeArcFlag, 0, x4, y4,
      'Z'
    ].join(' ');
  }

  private generateChartSegments(): void {
    this.chartSegments = this.legendItems.map(item => ({
      ...item,
      value: this.data[item.key as keyof GradeBreakdownData],
      percentage: this.data[item.key as keyof GradeBreakdownData]
    }));
  }


}
